import httpRequest from '@/libs/httpRequest'
import Axios from 'axios'

/*
export const queryAirport = (params) => {
  console.log(params)
  return httpRequest.request({
    url: '/api/hello',
    method: 'get',
    params: params
  })
}
*/

export const authorize = () => {
  return httpRequest.request({
    url: '/api/base/authorize',
    method: 'get'
  })
}
export function queryAirport (params, _this) {
  const CancelToken = Axios.CancelToken
  return httpRequest.request({
    url: '/api/base/airport',
    method: 'get',
    params: params,
    cancelToken: new CancelToken(function executorv (c) {
      _this.cancelAjax = c
    })
  })
}

export const legsPreorder = (data) => {
  return httpRequest.request({
    url: '/api/base/legsporeorder',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/net-api.js